/** @format */

export enum PriceFilterOption {
    GROUP = 'price-group',
    RANGE = 'custom-range',
}

export enum CustomRangeField {
    FROM = 'from',
    TO = 'to',
}

export const DEFAULT_TEST_ID = 'price-filter-options';

export const MAX_CUSTOM_RANGE = 999_999_999;
